export default "__VITE_ASSET__CaGRCDix__"